module.exports = __webpack_public_path__ + "img/22_57.27314a42.png";